export const environment = {
    production: true,
    maintenance: false,
    backendUrl: 'https://api.deals-int.twint.ch/api/',
    defaultLanguage: 'de-ch',
    availableLanguages: ['de-ch', 'fr-ch', 'it-ch'],
    enableDebugging: 'modeso:*, dgoods:*, tsd:*, twint:*, ihub:*',
    dataDomain: 'deals-int.twint.ch',
};
